<template>
    <el-col :span="24" class="content-wrapper">
        <transition name="fade-transform" mode="out-in">
            <keep-alive>
                <router-view v-if="isRouterAlive"></router-view>
            </keep-alive>
        </transition>
    </el-col>
</template>

<script>
    export default {
        name: "Test",
        provide(){
            return{
                reload:this.reload
            }
        },
        data(){
            return {
                isRouterAlive:true,
            }
        },
        methods:{
            reload(){
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true
                });
            },
        }
    }
</script>

<style scoped>
    /* fade-transform */
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all .5s;
    }

    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }

    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

</style>


// WEBPACK FOOTER //
// src/views/Test.vue